// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-I":"I_dpu-detail-I__xbcJK"};